function range<T = number>(length: number, mapFunction?: (index: number) => T){
  return Array.from({ length }, (_value, i) => {
    return mapFunction ? mapFunction(i) : i;
  }) as T[];
}

export { range };